import {
  RefObject,
  ChangeEvent,
  ClipboardEvent,
  Dispatch,
  SetStateAction,
} from "react";

export const handleInputChange = (
  e: ChangeEvent<HTMLInputElement>,
  i: number,
  inputValues: string[],
  setInputValues: Dispatch<SetStateAction<string[]>>,
  inputRefs: RefObject<HTMLInputElement>[],
  numberOfBox: number = 4
) => {
  const newInputValues = [...inputValues];
  //newInputValues[i] = e.target.value;
  const inputValue = e.target.value;

  if (!isNaN(Number(inputValue)) && Number(inputValue) >= 0) {
    newInputValues[i] = inputValue;
    setInputValues(newInputValues);
    if (inputValue.length === 1 && i < numberOfBox - 1) {
      inputRefs[i + 1]?.current?.focus();
    } else if (inputValue.length === 0 && i > 0) {
      inputRefs[i - 1]?.current?.focus();
    }
  }
};

export const handlePaste = (
  e: ClipboardEvent<HTMLInputElement>,
  inputValues: string[],
  setInputValues: Dispatch<SetStateAction<string[]>>,
  inputRefs: RefObject<HTMLInputElement>[],
  numberOfBox: number = 4
) => {

  e.preventDefault();
  const pastedData = e.clipboardData.getData("text");
  const regexPattern = new RegExp(`^\\d{${numberOfBox}}$`);

  if (regexPattern.test(pastedData)) {
    const pinArray = pastedData.split("");
    pinArray?.forEach((digit, index) => {
      if (inputRefs[index] && index < inputRefs.length) {
        inputRefs[index].current!.value = digit;
        inputValues[index] = digit;
      }
    });
    setInputValues([...inputValues]);
  }
};
